import { FC, PropsWithChildren } from "react";
import cn from "classnames";

interface InputLabelProps {
    size?: "sm" | "md" | "lg";
    bold?: boolean;
    className?: string;
}

export const InputLabel: FC<PropsWithChildren<InputLabelProps>> = ({ children, size = "sm", bold = false, className }) => {
    const sizeClasses = {
        sm: "text-sm",
        md: "text-base",
        lg: "text-lg",
    };

    return <label className={cn(sizeClasses[size], "text-muted-body-text", bold && "font-bold", className)}>{children}:</label>;
};
